// extracted by mini-css-extract-plugin
module.exports = {"header":"_3S79a4uc","headerInner":"bky4Gw4t","body":"_37T6CEkw","button":"_1KOKelZ5","title":"_26Gke3pO","buttonWrapper":"_3nQFz8vP","contentWrapper":"_2zt3uJeQ"};